import React from "react";
import { useState } from "react";
import config from "../../../config/apiConfig";
import "./Footer.scss";

type Props = {
    tab: number;
    goToNext: () => void;
    goBack: () => void;
    publish: () => Promise<void>;
};

const Footer: React.FC<Props> = (props) => {
    const [loading, setLoading] = useState(false);

    const onPublish = async () => {
        setLoading(true);
        await props.publish();
        setLoading(false);
    };

    return (
        <footer className="feedback__footer">
            <div>
                <div className="steps">
                    <div
                        style={{
                            backgroundColor:
                                props.tab === 0 ? config.primary_color : "#eee",
                        }}
                    ></div>
                    <div
                        style={{
                            backgroundColor:
                                props.tab === 1 ? config.primary_color : "#eee",
                        }}
                    ></div>
                </div>
                <div style={{ fontSize: 14 }}>
                    {`Step ${props.tab + 1} out of 2`}
                </div>
            </div>

            <div className="section__right">
                <button
                    className="back__button"
                    onClick={() => props.goBack()}
                    disabled={props.tab === 0}
                >
                    Back
                </button>
                {props.tab === 0 ? (
                    <button
                        className="next__button"
                        onClick={() => props.goToNext()}
                    >
                        Next
                    </button>
                ) : (
                    <button
                        className="next__button"
                        disabled={loading}
                        onClick={() => onPublish()}
                    >
                        Publish feedback
                    </button>
                )}
            </div>
        </footer>
    );
};

export default Footer;
